// globals.ts
import { Injectable } from '@angular/core';

@Injectable()
export class Constant {
    public emailPattern: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9_]+\.)+[a-zA-Z]{2,}))$/;
    public namePattern: RegExp = /^([a-zàáâäçèéêëìíîïñòóôöùúûü_\']+(( |')[a-zàáâäçèéêëìíîïñòóôöùúûü_\']+)*)+([-]([a-zàáâäçèéêëìíîïñòóôöùúûü_\']+(( |')[a-zàáâäçèéêëìíîïñòóôöùúûü_\'']+)*)+)*$/i;
    public mobilePattern: RegExp = /^(0(6|7)[0-9]{8})$|^((6|7)[0-9]{8})$/
    public fixePattern: RegExp = /^(?:(?:\+|00)33|0)\s*[1234589](?:[\s.-]*\d{2}){4}$/
    public postalCodePattern: RegExp = /^[0-9]{5,5}$/
}



// WEBPACK FOOTER //
// ./src/app/helper/core/constant.ts